module.exports = __webpack_public_path__ + "img/gacha.2df8731a.svg";